<script>
  import Modal from '../Modal';
  import { IconButton } from '../Button';

  export let testid = undefined;
  export let size = undefined;
  export let position = undefined;
  export let fullheight = false;
  export let allowClose = true;

  let modal;

  export function show() {
    modal.show();
  }
  export function dismiss(value) {
    modal.dismiss(value);
  }
</script>

<Modal {size} {position} {testid} {fullheight} let:dismiss let:fullscreen bind:this={modal} on:dismiss on:remove>
  <div class='dialog dialog-header'>
    <div class='dialog-title' data-cy='dialog-title'>
      <slot name='title' {dismiss} />
    </div>
    {#if allowClose}
      <IconButton icon='close' on:click={dismiss} testid='close-dialog' />
    {/if}
  </div>

  <div class='dialog dialog-contents' class:fullscreen data-cy='dialog-contents'>
    <slot {dismiss} {fullscreen} />
  </div>

  <div class='dialog dialog-actions' data-cy='dialog-actions'>
    <slot name='action' {dismiss} />
  </div>
</Modal>

<style lang="postcss">
  .dialog {
    --Dialog--outer-space: var(--spacing--l);

    top: 24px;
    bottom: 24px;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    gap: var(--spacing--m);
    margin: var(--Dialog--outer-space) var(--Dialog--outer-space) var(--spacing--m) var(--Dialog--outer-space);
    flex-shrink: 0;

    & .dialog-title {
      font: var(--font--outfit-title-24);
      overflow: hidden;
      flex-grow: 1;
    }
  }

  .dialog-contents {
    padding: 0 var(--Dialog--outer-space);
    margin-bottom: var(--spacing--xl);
    min-height: 0;
    flex-grow: 1;
    overflow-y: auto;

    &.fullscreen {
      min-height: unset;
      overflow-y: visible;
      flex-shrink: 0;
    }

    /* If the dialog-contents is empty, remove the margin-bottom */
    &:empty {
      margin-bottom: 0;
    }
  }

  .dialog-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: var(--spacing--xs);
    margin: 0 var(--Dialog--outer-space) var(--Dialog--outer-space) var(--Dialog--outer-space) ;
    flex-shrink: 0;
  }
</style>
